import React from "react";

const southDakotaResources = [
  "My Safety Plan",
  "South Dakota Suicide Prevention",
  "Department of Social Services",
  "seizetheawkward",
  "liveinspired365",
  "journeyofhoped",
  "sdbheavioralhealth",
  "South Dakota National Alliance on Mental Health",
  "Peer Support",
];

const northDakotaResources = [
  "https://hhs.nd.gov",
  "Veterans",
  "mhand",
  "ncthives",
  "hhs.nd.gov",
  "nami north dakota",
];

const nationwideResources = [
  "The National Widowers' Organization",
  "Hopenet",
  "lyrahealth",
  "Safety plan",
  "National Alliance on Mental Illness",
  "National Institute for Mental Health",
  "Veterans Crisis Line",
  "Substance Abuse and Mental Health Services Administration (SAMHSA)",
  "How to Overcome Stigma in the workplace",
  "Dbs Alliance",
];

function ResourceList({ items }) {
  return (
    <div className="border-t border-gray-200">
      {items.map((item, index) => (
        <div
          key={index}
          className="border-b border-gray-200 py-2.5 text-[11px] md:text-[12px] text-gray-700"
        >
          {item}
        </div>
      ))}
    </div>
  );
}

function Resources() {
  return (
    <div className="min-h-screen bg-white text-black">
      {/* HERO */}
      <section className="bg-[#f7d9ea]">
        <div className="max-w-[1180px] mx-auto px-4 md:px-8 h-[115px] flex flex-col items-center justify-center text-center">
          <h1 className="text-[22px] md:text-[28px] font-extrabold tracking-wide">
            RESOURCES
          </h1>
          <p className="mt-1 text-[10px] md:text-[12px] text-gray-500">
            Home / Resources
          </p>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main className="max-w-[1180px] mx-auto px-4 md:px-8 pt-14 pb-20">
        <div className="grid lg:grid-cols-[1fr_250px] gap-10 lg:gap-8">
          {/* LEFT SIDE */}
          <div>
            {/* Top Two Columns */}
            <div className="grid md:grid-cols-2 gap-10 md:gap-16">
              <div>
                <h2 className="text-[14px] md:text-[16px] font-extrabold tracking-wide uppercase mb-3">
                  South Dakota
                </h2>
                <ResourceList items={southDakotaResources} />
              </div>

              <div>
                <h2 className="text-[14px] md:text-[16px] font-extrabold tracking-wide uppercase mb-3">
                  North Dakota
                </h2>
                <ResourceList items={northDakotaResources} />
              </div>
            </div>

            {/* Nationwide Section */}
            <div className="mt-8 md:mt-10">
              <h2 className="text-[14px] md:text-[16px] font-extrabold tracking-wide uppercase mb-3">
                Nationwide / USA-Wide (General)
              </h2>
              <ResourceList items={nationwideResources} />
            </div>

            {/* Quote Cards */}
            <div className="mt-8 md:mt-10 grid md:grid-cols-2 gap-6 max-w-[760px]">
              <div className="h-[150px] md:h-[160px] rounded-sm bg-gradient-to-r from-[#e6ac00] via-[#f0a53a] to-[#f38e67] text-white flex items-center justify-center px-8 text-center">
                <div>
                  <div className="text-[28px] leading-none mb-1">“</div>
                  <p className="text-[13px] md:text-[16px] font-extrabold leading-[1.35] uppercase tracking-wide">
                    There is hope, even when
                    <br />
                    your brain tells you there isn't.
                  </p>
                  <p className="mt-3 text-[9px] md:text-[10px] font-semibold">
                    — John Green
                  </p>
                </div>
              </div>

              <div className="h-[150px] md:h-[160px] rounded-sm bg-gradient-to-r from-[#50a7bf] via-[#59b7a9] to-[#7cc87d] text-white flex items-center justify-center px-8 text-center">
                <div>
                  <div className="text-[28px] leading-none mb-1">“</div>
                  <p className="text-[13px] md:text-[16px] font-extrabold leading-[1.35] uppercase tracking-wide">
                    What mental health needs
                    <br />
                    is more sunlight, more
                    <br />
                    candor, and more
                    <br />
                    unashamed conversation.
                  </p>
                  <p className="mt-3 text-[9px] md:text-[10px] font-semibold">
                    — Glenn Close
                  </p>
                </div>
              </div>
            </div>

            {/* Small image / logo placeholder like the screenshot */}
            <div className="mt-10">
              <img
                src="/upload/mentalhealth.jpg"
                alt=""
                className=" object-contain"
              />
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <aside className="pt-1">
            <div className="space-y-4">
              {/* NAMI Card */}
              <div className="border border-gray-200 p-3 bg-white">
                <div className="bg-[#1f6aa8] text-white px-4 py-5">
                  <div className="text-center">
                    <div className="text-[28px] font-extrabold tracking-tight leading-none">
                      nami
                    </div>
                    <div className="text-[10px] mt-1 opacity-95">
                      National Alliance on Mental Illness
                    </div>
                  </div>

                  <div className="mt-5 text-[10px] leading-[1.5]">
                    <p className="font-semibold text-[12px] mb-2">
                      NAMI HELPLINE
                    </p>
                    <p>
                      The NAMI HelpLine provides the one-on-one help and
                      information necessary to tackle tough challenges.
                    </p>

                    <p className="mt-3 font-semibold">Call</p>
                    <p>1-800-950-NAMI</p>

                    <p className="mt-3 font-semibold">Chat or Text</p>
                    <p>Text "HelpLine" to 62640</p>

                    <p className="mt-3 font-semibold">In Crisis?</p>
                    <p>Call or Text 988</p>
                  </div>
                </div>
              </div>

              {/* 988 Card */}
              <div className="border border-gray-200 p-3 bg-white">
                <div className="bg-[#232a64] text-white px-4 py-5 text-center">
                  <div className="text-[46px] font-extrabold leading-none">
                    988
                  </div>
                  <div className="mt-2 text-[20px] font-bold tracking-[0.18em] leading-tight">
                    SUICIDE
                    <br />
                    &amp; CRISIS
                    <br />
                    LIFELINE
                  </div>
                </div>

                <div className="mt-3 text-[#6aa0d0] text-[11px] leading-[1.35]">
                  <p className="font-semibold text-[12px] text-[#4a8dc4]">
                    988 Suicide &amp; Crisis Lifeline
                  </p>
                  <p className="mt-1">
                    We can help prevent suicide. The 988 Lifeline provides 24/7,
                    free and confidential support for people in distress,
                    prevention and crisis resources for you or your loved ones,
                    and best practices for professionals in the United States.
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </main>

      {/* SUBSCRIBE BAR */}
      <section className="bg-[#f4f4f4] border-t border-gray-200">
        <div className="max-w-[1180px] mx-auto px-4 md:px-8 py-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-5">
            <h3 className="text-[12px] md:text-[14px] font-extrabold tracking-wide uppercase">
              Get The Latest Updates
            </h3>

            <div className="flex w-full md:w-auto items-center">
              <input
                type="email"
                placeholder="Enter your email"
                className="h-9 md:h-10 w-full md:w-[215px] border border-gray-300 bg-white px-3 text-[11px] outline-none"
              />
              <button className="h-9 md:h-10 px-5 bg-black text-white text-[10px] md:text-[11px] font-semibold uppercase">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Resources;